import script from "./ConfirmValidate.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmValidate.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmValidate.vue?vue&type=style&index=0&id=3354a28e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3354a28e"]])

export default __exports__